module.exports = __webpack_public_path__ + "media/images/logos/windeurope-annual2025-cdcce783f779977e23990ccf53ac5e8c.svg";